
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3.0201 15.62C2.9401 18.04 3.3401 19.96 3.6901 20.31C4.0401 20.66 5.9701 21.07 8.3801 20.98L3.0201 15.62Z' fill='#323232'/><path d='M13.0803 3.27997C10.7503 3.69997 8.29027 4.61997 6.46027 6.45997C4.63027 8.29997 3.70027 10.75 3.28027 13.08L10.9103 20.71C13.2503 20.3 15.7003 19.37 17.5303 17.53C19.3603 15.69 20.2903 13.24 20.7103 10.91L13.0803 3.27997ZM14.8003 10.6L10.6003 14.8C10.2103 15.19 9.59027 15.19 9.20027 14.8C8.81027 14.41 8.81027 13.79 9.20027 13.4L13.4003 9.19997C13.7903 8.80997 14.4103 8.80997 14.8003 9.19997C15.1903 9.58997 15.1903 10.21 14.8003 10.6Z' fill='#323232'/><path d='M20.9801 8.37998C21.0601 5.95998 20.6601 4.03998 20.3101 3.68998C19.9601 3.33998 18.0301 2.92998 15.6201 3.01998L20.9801 8.37998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sports-football`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSportsFootball

    ```js
    <b-new-b-icon-sports-football />
    ```
</docs>


